import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPostRequest,
  IUseAddMutation,
  IAddFn,
  ISafetyCaseHazardMitigation,
  ISafetyCaseHazardMitigationUpsert,
} from '../../interfaces'

const getCreateSafetyCaseHazardMitigationMutationRequest: IGetPostRequest = () => ({
  method: 'post',
  url: `${config.baseUrl}/sms/Mitigations`,
})

const useCreateSafetyCaseHazardMitigationMutation: IUseAddMutation<
  ISafetyCaseHazardMitigation,
  ISafetyCaseHazardMitigationUpsert
> = (params, options = {}) => {
  const request = useMemo(() => getCreateSafetyCaseHazardMitigationMutationRequest(params), [params])

  const createSafetyCaseHazardMitigation: IAddFn<ISafetyCaseHazardMitigationUpsert, ISafetyCaseHazardMitigation> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseHazardMitigation, Error, ISafetyCaseHazardMitigationUpsert>({
    mutationFn: createSafetyCaseHazardMitigation,
    ...options,
  })

  return response
}

export default useCreateSafetyCaseHazardMitigationMutation
